import { render, staticRenderFns } from "./feedbackList.vue?vue&type=template&id=348537f9&scoped=true&"
import script from "./feedbackList.vue?vue&type=script&lang=js&"
export * from "./feedbackList.vue?vue&type=script&lang=js&"
import style0 from "./feedbackList.vue?vue&type=style&index=0&id=348537f9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348537f9",
  null
  
)

export default component.exports